<template>
    <div class="Header">
        <div class="container">
            <header class="Header__title-block hide-mobile">
                <router-link :to="{name: 'object-list'}">
                    <LogoIcon/>
                </router-link>
                <div class="Header__title">{{ title }}</div>
            </header>
        </div>
        <div class="Header__panel">
            <div class="container">
                <HeaderPanel />
            </div>
        </div>
    </div>
</template>

<script>

import LogoIcon from '@/assets/image/logo/logo.svg?inline'
import HeaderPanel from "@/components/HeaderPanel";

export default {
    name: "Header",
    components: {
        LogoIcon,
        HeaderPanel,
    },
    computed: {
        title() {
            document.title = 'Prime - '+this.$store.state.cabinet.title;
            return this.$store.state.cabinet.title;
        },
        head() {
            return {
                title: 'Название страницы'
            }
        }
    }
}
</script>

<style lang="scss">
.Header {
  z-index: 100;
  position: fixed;//relative;
    width: 100%;
  background-color: $bg;

  &__title-block {
    display: none;//flex;
    align-items: center;
    padding: 20px 0;
  }

  &__title {
    font-size: 16px;
    line-height: 24px;
    margin-left: 32px;

  }

  &__panel {
    background-color: $white;
    box-shadow: $BlockShadow;

  }
}
</style>